import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
const router = new VueRouter({
    mode: "hash",
    // mode: "history",
    routes: [
        {
            path: "/",
            component: Home,
            children: [
                {
                    path: "",
                    component: () => import("@/views/dataScreening/DataScreening.vue"),
                    meta: {
                        title: "数据总览"
                    }
                },
                {
                    path: "/programmeManagement",
                    component: () => import("@/views/programmeManagement/ProgrammeManagement.vue"),
                    meta: {
                        title: "方案管理"
                    }
                },
                {
                    path: "/collectionManagement",
                    component: () => import("@/views/collectionManagement/CollectionManagement.vue"),
                    meta: {
                        title: "收藏管理"
                    }
                },
                {
                    path: "/modelManagement",
                    component: () => import("@/views/modelManagement/ModelManagement.vue"),
                    meta: {
                        title: "模型管理"
                    }
                },
                {
                    path: "/modelBinding",
                    component: () => import("@/views/modelManagement/modelBinding.vue"),
                    meta: {
                        title: "模型管理"
                    }
                },
                {
                    path: "/helpRecord",
                    component: () => import("@/views/helpRecord/HelpRecord.vue"),
                    meta: {
                        title: "帮助记录"
                    }
                },
            ]
        },
        {
            path: "/login",
            component: () => import("@/views/login/Login.vue"),
            meta: {
                title: "登录"
            }
        },
    ]
})
export default router
